<button
  type="button"
  class="core-ui-stat-card"
  [class.is-selected]="selected"
  [attr.aria-pressed]="selected"
  [disabled]="disabled"
  (click)="clicked.emit()"
>
  <span class="core-ui-stat-card__label">
    {{ label }}
    <span
      *ngIf="indicator"
      class="core-ui-stat-card__indicator"
      [attr.data-tone]="indicator"
      aria-hidden="true"
    ></span>
  </span>
  <span class="core-ui-stat-card__body">
    <strong>{{ value }}</strong>
    <span *ngIf="description">{{ description }}</span>
  </span>
</button>
